
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.429 1.257H2.57c-.568 0-1.028.46-1.028 1.029v11.428c0 .568.46 1.029 1.028 1.029H9.43c.568 0 1.028-.46 1.028-1.029V2.286c0-.568-.46-1.029-1.028-1.029zM2.57 0A2.286 2.286 0 00.286 2.286v11.428A2.286 2.286 0 002.57 16H9.43a2.286 2.286 0 002.285-2.286V2.286A2.286 2.286 0 009.43 0H2.57z","fill":"#9DA7B2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.143 13.143c0-.316.256-.572.571-.572h4.572a.571.571 0 010 1.143H3.714a.571.571 0 01-.571-.571zM4.286 2.857c0-.315.256-.571.571-.571h2.286a.571.571 0 010 1.143H4.857a.571.571 0 01-.571-.572z","fill":"#9DA7B2"}})])
          )
        }
      }
    